module.exports = __webpack_public_path__ + "img/Jump Casting124.5620b319.jpg";